import React, { useState, useEffect } from 'react';
import ProductCard from './ProductCard';
import './FeaturedProducts.css';
import API_BASE_URL from '../api/Config';

const FeaturedProducts = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const handleAddToCart = (product) => {
    console.log('Added to cart:', product);
    // Add your cart logic here
  };

  const handleWishlistToggle = (product) => {
    console.log('Wishlist toggled:', product);
    // Add your wishlist logic here
  };

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${API_BASE_URL}/products/latest`);
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const data = await response.json();
        
        // Transform API data to match ProductCard expected format
        const transformedProducts = data.products.map(product => {
          const discountedPrice = product.discount > 0 
            ? product.price * (1 - product.discount / 100)
            : product.price;
          
          return {
            id: product.id,
            name: product.name,
            price: `KSh ${discountedPrice.toLocaleString()}`,
            originalPrice: product.discount > 0 ? `KSh ${product.price.toLocaleString()}` : null,
            image: product.image_fullpath?.[0] || '/placeholder-image.jpg',
            description: product.description?.replace(/<[^>]*>/g, '').substring(0, 100) || 'No description available',
            discount: product.discount || 0,
            unit: product.unit,
            stock: product.total_stock,
            variations: product.variations
          };
        });
        
        // Take first 10 products
        setProducts(transformedProducts.slice(0, 10));
        setError(null);
      } catch (err) {
        console.error('Error fetching products:', err);
        setError('Failed to load products. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  if (loading) {
    return (
      <section className="featured-products">
        <div className="featured-products-content">
          <h4 className="featured-title">Featured Products</h4>
          <h5 className="featured-subtitle">Explore Our Top Picks</h5>
          <div className="loading-spinn">Loading products...</div>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section className="featured-products">
        <div className="featured-products-content">
          <h4 className="featured-title">Featured Products</h4>
          <h5 className="featured-subtitle">Explore Our Top Picks</h5>
          <div className="error-message">{error}</div>
        </div>
      </section>
    );
  }

  return (
    <section className="featured-products">
      <div className="featured-products-content">
        <h4 className="featured-title">Featured Products</h4>
        <h5 className="featured-subtitle">Explore Our Top Picks</h5>
        
        <div className="products-grid">
          {products.map((product) => (
            <ProductCard 
              key={product.id} 
              product={product}
              onAddToCart={handleAddToCart}
              onWishlistToggle={handleWishlistToggle}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedProducts;